module.exports = Object.freeze({
    THEME_NAME: 'swisstech',
    // APP_URL: process.env.REACT_APP_URL,
    // APP_BASE_URL: process.env.REACT_APP_BASE_URL,
    // APP_URL: 'http://localhost:3000',
    // APP_BASE_URL: 'https://localhost:4000',
    APP_URL: 'https://app.swisstech.dev',
    APP_BASE_URL: 'https://sbx.swisstech.dev',
    APPLICATION_INSIGHTS_INSTRUMENTATION_KEY: process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
    GLOBALPASS_SCREENING_WIDGET_SCRIPT_PATH: process.env.REACT_APP_GLOBALPASS_SCREENING_WIDGET_SCRIPT_PATH,
    RECAPTCHA_SITE_KEY: '6LdpxPwqAAAAANeIL-WZ2KZ8j3Jf4jdVxtThhG6R',
    IS_PRODUCTION: true,
    RECAPTCHA_V2_SITE_KEY: '6LfbxPwqAAAAADB3GTAXTzLAdSC7HJiHZfyr-ZU8',
    MUI_LICENCE_KEY: '279e90193ef43d828b872bf2438aa5edTz0xMDc0ODQsRT0xNzcwNTA4Nzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=',
    FIREBASE_API_KEY: 'AIzaSyBE0VNfYtyKpP67gTHnXN634gXtuu52w_w',
    FIREBASE_AUTH_DOMAIN: 'atlas-sandbox-16365.firebaseapp.com',
    FIREBASE_PROJECT_ID: 'atlas-sandbox-16365',
    FIREBASE_STORAGE_BUCKET: 'atlas-sandbox-16365.firebasestorage.app',
    FIREBASE_MESSAGING_SENDER_ID: '222054190327',
    FIREBASE_APP_ID: '1:222054190327:web:0262d7110f3891ef4fd7f2',
    FIREBASE_MEASUREMENT_ID: 'G-QHZDY3N06S',
})
